import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardMedia } from '@material-ui/core';
import { Lightbox } from 'kangarootime-ui';

const LightboxPhoto = ({ isOpen, onClose, imageUrl }) => (
  <Lightbox isOpen={isOpen} onClose={onClose}>
    <div className='flex' style={{ justifyContent: 'center', alignItems: 'center', marginTop: 32 }} onClick={onClose}>
      <Card style={{ width: 540 }} onClick={event => { event.preventDefault(); event.stopPropagation(); }}>
        <CardMedia image={imageUrl} style={{ height: 320 }} />
      </Card>
    </div>
  </Lightbox>
);

LightboxPhoto.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  imageUrl: PropTypes.string
};

export default LightboxPhoto;
